import { gql } from '@apollo/client';

export type GetCSVFileRowSelectColumnsType = {
  rows: {
    id: string;
    index: number;
    values: string[];
  }[];
};

export const GET_CSVFILE_ROWS_SELECTCOLUMNS = gql`
  query GetCSVFileRowsSelectColumns($input: CSVFileRowSelectColumnsInput!) {
    rows: getCSVFileRowsSelectColumns(input: $input) {
      id
      index
      values
    }
  }
`;
